<template>
	<div class="fb">
		<div class="fb-track">
			<div v-for="s in segmenti" :key="s.chiave" class="fb-seg" :class="{ 'fb-seg--on': s.attiva, 'fb-seg--ko': s.problema }" :style="{ left: s.left + '%', width: s.width + '%' }" :title="s.titolo">
				<span v-if="s.width > 9">{{ s.prezzo }}</span>
			</div>
		</div>
		<div class="fb-scale">
			<span>0 kg</span>
			<span>{{ fine }}</span>
		</div>
	</div>
</template>

<script>
import { kg, prezzo, pesi } from './formato';

// barra orizzontale dei pesi: una fascia per segmento, la fascia attiva evidenziata
export default {
	name: 'FasceBarra',
	props: {
		// [{ min, max, price, attiva?, problema?, chiave? }]
		fasce: { type: Array, default: () => [] },
	},
	computed: {
		massimo() {
			return Math.max(1, ...this.fasce.map(f => Number(f.max) || 0), ...this.fasce.map(f => Number(f.min) || 0));
		},
		fine() {
			return kg(this.massimo);
		},
		segmenti() {
			return this.fasce.map((f, i) => {
				const min = Math.max(0, Number(f.min) || 0);
				const max = Math.max(min, Number(f.max) || 0);
				return {
					chiave: f.chiave || i,
					left: (min / this.massimo) * 100,
					width: Math.max(1.5, ((max - min) / this.massimo) * 100),
					prezzo: prezzo(f.price),
					titolo: `${pesi(f.min, f.max)} · ${prezzo(f.price)}`,
					attiva: !!f.attiva,
					problema: !!f.problema,
				};
			});
		},
	},
};
</script>

<style scoped>
.fb-track {
	position: relative;
	height: 26px;
	border-radius: 6px;
	background: repeating-linear-gradient(45deg, #eef2f7, #eef2f7 6px, #f7f9fc 6px, #f7f9fc 12px);
	border: 1px solid #e1e7ef;
	overflow: hidden;
}
.fb-seg {
	position: absolute;
	top: 2px;
	bottom: 2px;
	border-radius: 4px;
	background: #cfe0f5;
	border: 1px solid #fff;
	color: #1a4f9c;
	font-size: 11px;
	font-weight: 600;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	white-space: nowrap;
}
.fb-seg--on {
	background: #01579b;
	color: #fff;
}
.fb-seg--ko {
	background: #fde7e7;
	color: #b3261e;
	border-color: #f5b5b0;
}
.fb-scale {
	display: flex;
	justify-content: space-between;
	font-size: 11px;
	color: #5f6b7a;
	margin-top: 2px;
}
</style>
